import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { prakrutiSteps } from "../Data";
import { FaCheck, FaChevronLeft, FaChevronRight, FaLock, } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "./Recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import sendMetaEvent from "../Utils/metaTracking";

const PrakrutiAnalysisForm=()=>{
     const [currentStep, setCurrentStep] = useState(0);
     const navigate = useNavigate()
     const [answers, setAnswers] = useState({});
     const [quizStarted, setQuizStarted] = useState(false);
     const contentRef = useRef(null);
     const [loading, setLoading] = useState(false);
     const generateToken = useRecaptcha();

    const step = prakrutiSteps[currentStep];
    const [submitted, setSubmitted] = useState(false);
    const [basicInfo, setBasicInfo] = useState({
  name: "",
  age: "",
  gender: "",
  email: "",
  contactNumber: "",
});

const trackQuizStart = () => {
  if (quizStarted) return;

  setQuizStarted(true);
  sendMetaEvent("QuizStarted");
};


const generateDoshaChart = () => {
  let vata = 0;
  let pitta = 0;
  let kapha = 0;

  prakrutiSteps
    .filter(
      (item) =>
        !item.isBasicInfo &&
        !item.isReview
    )
    .forEach((category) => {
      category.questions.forEach((question) => {
        const selectedAnswer = answers[question.id];

        if (selectedAnswer === 0) {
          vata++;
        } else if (selectedAnswer === 1) {
          pitta++;
        } else if (selectedAnswer === 2) {
          kapha++;
        }
      });
    });

  // Total Prakruti questions
  const totalQuestions = vata + pitta + kapha;

  // Percentage calculation
  const vataPercentage =
    ((vata / totalQuestions) * 100).toFixed(1);

  const pittaPercentage =
    ((pitta / totalQuestions) * 100).toFixed(1);

  const kaphaPercentage =
    ((kapha / totalQuestions) * 100).toFixed(1);

  // Fixed maximum because all questions are compulsory
  const maxQuestions = totalQuestions;

  // Graph height
  const graphHeight = 220;

  const vataHeight =
    (vata / maxQuestions) * graphHeight;

  const pittaHeight =
    (pitta / maxQuestions) * graphHeight;

  const kaphaHeight =
    (kapha / maxQuestions) * graphHeight;

  return `
    <div
      style="
        margin-top:40px;
        background:#F6F5F0;
        border:1px solid #ECE6DA;
        border-radius:16px;
        padding:35px 30px;
      "
    >

      <!-- Heading -->

      <h2
        style="
          margin:0 0 8px;
          font-family:Georgia,serif;
          color:#1E3A2F;
          font-size:25px;
          text-align:center;
        "
      >
        Prakruti Analysis Result
      </h2>

      <p
        style="
          margin:0 0 30px;
          color:#666;
          font-size:14px;
          line-height:1.6;
          text-align:center;
        "
      >
        Distribution of your responses across the three
        Ayurvedic Doshas.
      </p>


      <!-- GRAPH -->

      <table
        width="100%"
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="border-collapse:collapse;"
      >

        <tr>

          <!-- Y AXIS -->

          <td
            width="45"
            valign="bottom"
            style="padding:0;"
          >

            <table
              width="100%"
              height="${graphHeight}"
              cellpadding="0"
              cellspacing="0"
              border="0"
              style="border-collapse:collapse;"
            >

              <tr>
                <td
                  valign="top"
                  align="right"
                  style="
                    font-size:11px;
                    color:#777;
                    padding-right:8px;
                  "
                >
                  ${maxQuestions}
                </td>
              </tr>

              <tr>
                <td
                  valign="middle"
                  align="right"
                  style="
                    font-size:11px;
                    color:#777;
                    padding-right:8px;
                  "
                >
                  ${Math.round(maxQuestions * 0.75)}
                </td>
              </tr>

              <tr>
                <td
                  valign="middle"
                  align="right"
                  style="
                    font-size:11px;
                    color:#777;
                    padding-right:8px;
                  "
                >
                  ${Math.round(maxQuestions * 0.5)}
                </td>
              </tr>

              <tr>
                <td
                  valign="middle"
                  align="right"
                  style="
                    font-size:11px;
                    color:#777;
                    padding-right:8px;
                  "
                >
                  ${Math.round(maxQuestions * 0.25)}
                </td>
              </tr>

              <tr>
                <td
                  valign="bottom"
                  align="right"
                  style="
                    font-size:11px;
                    color:#777;
                    padding-right:8px;
                  "
                >
                  0
                </td>
              </tr>

            </table>

          </td>


          <!-- GRAPH AREA -->

          <td
            valign="bottom"
            style="
              border-left:1px solid #C8CCBF;
              border-bottom:1px solid #C8CCBF;
            "
          >

            <table
              width="100%"
              height="${graphHeight}"
              cellpadding="0"
              cellspacing="0"
              border="0"
              style="border-collapse:collapse;"
            >

              <tr>

                <!-- VATA -->

                <td
                  width="33.33%"
                  valign="bottom"
                  align="center"
                  style="
                    border-bottom:1px dashed #D9DDD4;
                    border-right:1px solid #ECEEE7;
                    padding:0 10px;
                  "
                >

                  <div
                    style="
                      color:#271F12;
                      font-size:18px;
                      font-weight:600;
                      margin-bottom:8px;
                    "
                  >
                    ${vata}
                  </div>

                  <div
                    style="
                      width:65px;
                      height:${vataHeight}px;
                      background:#3F542D;
                      border-radius:8px 8px 0 0;
                      margin:0 auto;
                    "
                  ></div>

                </td>


                <!-- PITTA -->

                <td
                  width="33.33%"
                  valign="bottom"
                  align="center"
                  style="
                    border-bottom:1px dashed #D9DDD4;
                    border-right:1px solid #ECEEE7;
                    padding:0 10px;
                  "
                >

                  <div
                    style="
                      color:#271F12;
                      font-size:18px;
                      font-weight:600;
                      margin-bottom:8px;
                    "
                  >
                    ${pitta}
                  </div>

                  <div
                    style="
                      width:65px;
                      height:${pittaHeight}px;
                      background:#C49A5A;
                      border-radius:8px 8px 0 0;
                      margin:0 auto;
                    "
                  ></div>

                </td>


                <!-- KAPHA -->

                <td
                  width="33.33%"
                  valign="bottom"
                  align="center"
                  style="
                    border-bottom:1px dashed #D9DDD4;
                    padding:0 10px;
                  "
                >

                  <div
                    style="
                      color:#271F12;
                      font-size:18px;
                      font-weight:600;
                      margin-bottom:8px;
                    "
                  >
                    ${kapha}
                  </div>

                  <div
                    style="
                      width:65px;
                      height:${kaphaHeight}px;
                      background:#97A278;
                      border-radius:8px 8px 0 0;
                      margin:0 auto;
                    "
                  ></div>

                </td>

              </tr>

            </table>

          </td>

        </tr>


        <!-- X AXIS -->

        <tr>

          <td></td>

          <td>

            <table
              width="100%"
              cellpadding="0"
              cellspacing="0"
              border="0"
              style="border-collapse:collapse;"
            >

              <tr>

                <td
                  width="33.33%"
                  align="center"
                  style="
                    padding-top:12px;
                    font-size:15px;
                    font-weight:600;
                    color:#1E3A2F;
                  "
                >
                  Vata
                </td>

                <td
                  width="33.33%"
                  align="center"
                  style="
                    padding-top:12px;
                    font-size:15px;
                    font-weight:600;
                    color:#1E3A2F;
                  "
                >
                  Pitta
                </td>

                <td
                  width="33.33%"
                  align="center"
                  style="
                    padding-top:12px;
                    font-size:15px;
                    font-weight:600;
                    color:#1E3A2F;
                  "
                >
                  Kapha
                </td>

              </tr>

            </table>

          </td>

        </tr>

      </table>


      <!-- AXIS LABELS -->

      <table
        width="100%"
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="margin-top:10px;"
      >

        <tr>

          <td
            width="50%"
            align="left"
            style="
              color:#777;
              font-size:11px;
            "
          >
            Questions Answered
          </td>

          <td
            width="50%"
            align="right"
            style="
              color:#777;
              font-size:11px;
            "
          >
            Total: ${totalQuestions}
          </td>

        </tr>

      </table>


      <!-- DOSHA SUMMARY -->

      <table
        width="100%"
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="
          margin-top:30px;
          border-collapse:collapse;
        "
      >

        <tr>

          <!-- VATA -->

          <td
            width="33.33%"
            align="center"
            style="
              padding:18px 8px;
              border:1px solid #ECE6DA;
              background:#fff;
            "
          >

            <div
              style="
                font-size:14px;
                color:#1E3A2F;
                font-weight:600;
                margin-bottom:6px;
              "
            >
              Vata
            </div>

            <div
              style="
                font-size:22px;
                color:#271F12;
                font-weight:600;
              "
            >
              ${vata}
            </div>

            <div
              style="
                font-size:12px;
                color:#777;
                margin-top:4px;
              "
            >
              ${vataPercentage}%
            </div>

          </td>


          <!-- PITTA -->

          <td
            width="33.33%"
            align="center"
            style="
              padding:18px 8px;
              border:1px solid #ECE6DA;
              background:#fff;
            "
          >

            <div
              style="
                font-size:14px;
                color:#1E3A2F;
                font-weight:600;
                margin-bottom:6px;
              "
            >
              Pitta
            </div>

            <div
              style="
                font-size:22px;
                color:#271F12;
                font-weight:600;
              "
            >
              ${pitta}
            </div>

            <div
              style="
                font-size:12px;
                color:#777;
                margin-top:4px;
              "
            >
              ${pittaPercentage}%
            </div>

          </td>


          <!-- KAPHA -->

          <td
            width="33.33%"
            align="center"
            style="
              padding:18px 8px;
              border:1px solid #ECE6DA;
              background:#fff;
            "
          >

            <div
              style="
                font-size:14px;
                color:#1E3A2F;
                font-weight:600;
                margin-bottom:6px;
              "
            >
              Kapha
            </div>

            <div
              style="
                font-size:22px;
                color:#271F12;
                font-weight:600;
              "
            >
              ${kapha}
            </div>

            <div
              style="
                font-size:12px;
                color:#777;
                margin-top:4px;
              "
            >
              ${kaphaPercentage}%
            </div>

          </td>

        </tr>

      </table>


      <p
        style="
          margin:20px 0 0;
          text-align:center;
          color:#777;
          font-size:12px;
          line-height:1.6;
        "
      >
        The percentages represent the proportion of selected
        responses associated with each Dosha.
      </p>

    </div>
  `;
};

const handleSubmit = async () => {

  if (!basicInfo.name)
    return toast.error("Please enter your name");

  if (!basicInfo.age)
    return toast.error("Please enter your age");

  if (!basicInfo.gender)
    return toast.error("Please select gender");

  if (!basicInfo.email)
    return toast.error("Please enter email address");

  if (!basicInfo.contactNumber)
    return toast.error("Please enter contact number");

const phoneDigits = basicInfo.contactNumber.replace(/\D/g, "");

if (phoneDigits.length < 10 || phoneDigits.length > 15) {
  return toast.error("Please enter a valid contact number");
}

  setLoading(true);
  generateToken(async (token) => {

  try {

  let answersHtml = "";
  const doshaChartHtml = generateDoshaChart();

prakrutiSteps
  .filter(
    (item) =>
      !item.isBasicInfo &&
      !item.isReview
  )
  .forEach((category) => {

    answersHtml += `
      <tr>
        <td
          style="
            background:#1E3A2F;
            padding:10px 20px;
            color:#ffffff;
            font-size:16px;
            line-height:1.4;
            font-weight:600;
          "
        >
          ${category.title}
        </td>
      </tr>
    `;

    category.questions.forEach((question) => {

      answersHtml += `
        <tr>
          <td
            style="
              padding:10px 20px;
              border-bottom:1px solid #ECE6DA;
            "
          >

            <div
              style="
                font-weight:600;
                color:#271F12;
                margin-bottom:4px;
                font-size:13px;
                line-height:1.4;
              "
            >
              ${question.title}
            </div>

            <div
              style="
                color:#555555;
                font-size:13px;
                line-height:1.5;
              "
            >
              ${
                question.options[
                  answers[question.id]
                ]
              }
            </div>

          </td>
        </tr>
      `;
    });
  });

  const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Lf_Qb4tAAAAAA35Wmjx9ZuK_6_NmESyX4-fAe3p"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;
        
      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }


    const adminTemplate = `
<div
  style="
    background:#F6F5F0;
    padding:30px 20px;
    font-family:'Trebuchet MS',Arial,sans-serif;
    color:#271F12;
  "
>

  <table
    width="100%"
    cellpadding="0"
    cellspacing="0"
    border="0"
  >
    <tr>
      <td align="center">

        <!-- MAIN CONTAINER -->

        <table
          width="800"
          cellpadding="0"
          cellspacing="0"
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 12px 35px rgba(0,0,0,.07);
          "
        >

          <!-- TOP GOLD LINE -->

          <tr>
            <td
              style="
                height:6px;
                line-height:6px;
                font-size:0;
                background:#C49A5A;
              "
            >
              &nbsp;
            </td>
          </tr>


          <!-- HEADER -->

          <tr>
            <td
              style="
                background:#1E3A2F;
                padding:35px 30px;
                text-align:center;
              "
            >

             <img
      src="https://msayurved.com/Images/white-logo.svg"
      alt="Dr. Jigar Gor Ayurveda"
      width="180"
      style="
        display:block;
        max-width:180px;
        width:100%;
        height:auto;
        margin:0 auto 20px;
        border:0;
      "
    />

              <div
                style="
                  display:inline-block;
                  padding:6px 16px;
                  background:rgba(255,255,255,.12);
                  border-radius:30px;
                  font-size:11px;
                  line-height:1.3;
                  letter-spacing:1.8px;
                  color:#ffffff;
                "
              >
                PRAKRUTI ANALYSIS
              </div>


              <h1
                style="
                  margin:14px 0 0;
                  padding:0;
                  font-size:28px;
                  line-height:1.3;
                  font-family:Georgia,serif;
                  font-weight:500;
                  color:#ffffff;
                "
              >
                New Analysis Submission
              </h1>


              <p
                style="
                  margin:10px 0 0;
                  padding:0;
                  color:#E6ECE8;
                  font-size:13px;
                  line-height:1.5;
                "
              >
                A new Prakruti Analysis has been submitted from the website.
              </p>

            </td>
          </tr>


          <!-- MAIN CONTENT -->

          <tr>
            <td
              style="
                padding:30px;
              "
            >


              <!-- BASIC INFORMATION -->

              <h2
                style="
                  margin:0 0 14px;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:22px;
                  line-height:1.3;
                  font-weight:500;
                  color:#1E3A2F;
                "
              >
                Basic Information
              </h2>


              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  border:1px solid #ECE6DA;
                  border-radius:12px;
                  overflow:hidden;
                "
              >

                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Name:</strong>
                    ${basicInfo.name}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Age:</strong>
                    ${basicInfo.age}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Gender:</strong>
                    ${basicInfo.gender}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Email:</strong>
                    ${basicInfo.email}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                    "
                  >
                    <strong>Contact:</strong>
                    ${basicInfo.contactNumber}
                  </td>
                </tr>

              </table>


              <!-- DOSHA GRAPH -->

              ${doshaChartHtml}


              <!-- PRAKRUTI RESPONSES -->

              <h2
                style="
                  margin:30px 0 14px;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:22px;
                  line-height:1.3;
                  font-weight:500;
                  color:#1E3A2F;
                "
              >
                Prakruti Responses
              </h2>


              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  border:1px solid #ECE6DA;
                  border-radius:12px;
                  overflow:hidden;
                "
              >

                ${answersHtml}

              </table>


              <!-- DISCLAIMER -->

              <div
                style="
                  margin-top:30px;
                  padding:20px 22px;
                  background:#F6F5F0;
                  border:1px solid #ECE6DA;
                  border-left:4px solid #C49A5A;
                  border-radius:10px;
                "
              >

                <h3
                  style="
                    margin:0 0 12px;
                    padding:0;
                    font-family:Georgia,serif;
                    color:#1E3A2F;
                    font-size:18px;
                    line-height:1.3;
                    font-weight:600;
                  "
                >
                  Please Note that:
                </h3>


                <p
                  style="
                    margin:0 0 10px;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Dynamic Nature of Prakruti:</strong>
                  The Prakruti analysis aims to assess the current dosha
                  conditions of your body. Please be aware that these
                  conditions are subject to change based on various factors
                  including location, time, environment, diet, seasons,
                  and personal habits.
                </p>


                <p
                  style="
                    margin:0 0 10px;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Limitations of Self-Medication:</strong>
                  It is crucial to understand that Prakruti analysis is not
                  a comprehensive diagnostic tool and should not be used
                  for self-medication.
                </p>


                <p
                  style="
                    margin:0;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Expert Guidance Required:</strong>
                  For accurate diagnosis and appropriate treatment,
                  consultation with an Ayurveda expert is essential.
                  We strongly recommend seeking the advice and input of
                  Dr. Jigar Gor for any health concerns or Ayurvedic
                  treatment plans. By adhering to these guidelines, you
                  ensure a holistic and accurate approach to your health
                  and well-being.
                </p>

              </div>

            </td>
          </tr>


          <!-- FOOTER -->

          <tr>
            <td
              style="
                background:#271F12;
                padding:25px 30px;
                text-align:center;
              "
            >

              <h3
                style="
                  margin:0;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:18px;
                  line-height:1.3;
                  font-weight:500;
                  color:#ffffff;
                "
              >
                Dr. Jigar Gor Ayurveda Clinic
              </h3>


              <p
                style="
                  margin:8px 0 0;
                  padding:0;
                  color:#D8C4A1;
                  font-size:11px;
                  line-height:1.5;
                "
              >
                Authentic Ayurveda • Panchkarma • Holistic Healing
              </p>

              <table
  role="presentation"
  cellpadding="0"
  cellspacing="0"
  border="0"
  style="margin:14px auto 0;"
>
  <tr>

    <!-- Email -->
    <td style="padding:0 8px;">
      <a
        href="mailto:dr.jigargor@yahoo.com"
        title="Email"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/new-post.png"
          width="22"
          height="22"
          alt="Email"
          style="display:block;border:0;"
        />
      </a>
    </td>

    <!-- Call -->
    <td style="padding:0 8px;">
      <a
        href="tel:+919099094847"
        title="Call"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/phone.png"
          width="22"
          height="22"
          alt="Call"
          style="display:block;border:0;"
        />
      </a>
    </td>

    <!-- WhatsApp -->
    <td style="padding:0 8px;">
      <a
        href="https://wa.me/+919099094847"
        title="WhatsApp"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/whatsapp.png"
          width="22"
          height="22"
          alt="WhatsApp"
          style="display:block;border:0;"
        />
      </a>
    </td>

  </tr>
</table>

            </td>
          </tr>


        </table>

      </td>
    </tr>
  </table>

</div>
`;


 const userTemplate = `
<div
  style="
    background:#F6F5F0;
    padding:30px 20px;
    font-family:'Trebuchet MS',Arial,sans-serif;
    color:#271F12;
  "
>

  <table
    width="100%"
    cellpadding="0"
    cellspacing="0"
    border="0"
  >
    <tr>
      <td align="center">

        <!-- MAIN CONTAINER -->

        <table
          width="800"
          cellpadding="0"
          cellspacing="0"
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 12px 35px rgba(0,0,0,.07);
          "
        >

          <!-- TOP GOLD LINE -->

          <tr>
            <td
              style="
                height:6px;
                line-height:6px;
                font-size:0;
                background:#C49A5A;
              "
            >
              &nbsp;
            </td>
          </tr>


          <!-- HEADER -->

          <tr>
            <td
              style="
                background:#1E3A2F;
                padding:35px 30px;
                text-align:center;
              "
            >

             <img
      src="https://msayurved.com/Images/white-logo.svg"
      alt="Dr. Jigar Gor Ayurveda"
      width="180"
      style="
        display:block;
        max-width:180px;
        width:100%;
        height:auto;
        margin:0 auto 20px;
        border:0;
      "
    />

              <div
                style="
                  display:inline-block;
                  padding:6px 16px;
                  background:rgba(255,255,255,.12);
                  border-radius:30px;
                  font-size:11px;
                  line-height:1.3;
                  letter-spacing:1.8px;
                  color:#ffffff;
                "
              >
                PRAKRUTI ANALYSIS
              </div>


              <h1
                style="
                  margin:14px 0 0;
                  padding:0;
                  font-size:28px;
                  line-height:1.3;
                  font-family:Georgia,serif;
                  font-weight:500;
                  color:#ffffff;
                "
              >
                Your Prakruti Analysis
              </h1>


              <p
                style="
                  margin:10px 0 0;
                  padding:0;
                  color:#E6ECE8;
                  font-size:13px;
                  line-height:1.5;
                "
              >
               Here the results of your prakurti analysis test submitted through Dr. Jigar Gor's Website.
              </p>

            </td>
          </tr>


          <!-- MAIN CONTENT -->

          <tr>
            <td
              style="
                padding:30px;
              "
            >


              <!-- BASIC INFORMATION -->

              <h2
                style="
                  margin:0 0 14px;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:22px;
                  line-height:1.3;
                  font-weight:500;
                  color:#1E3A2F;
                "
              >
                Basic Information
              </h2>


              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  border:1px solid #ECE6DA;
                  border-radius:12px;
                  overflow:hidden;
                "
              >

                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Name:</strong>
                    ${basicInfo.name}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Age:</strong>
                    ${basicInfo.age}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Gender:</strong>
                    ${basicInfo.gender}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                      border-bottom:1px solid #ECE6DA;
                    "
                  >
                    <strong>Email:</strong>
                    ${basicInfo.email}
                  </td>
                </tr>


                <tr>
                  <td
                    style="
                      padding:10px 20px;
                      font-size:13px;
                      line-height:1.4;
                    "
                  >
                    <strong>Contact:</strong>
                    ${basicInfo.contactNumber}
                  </td>
                </tr>

              </table>


              <!-- DOSHA GRAPH -->

              ${doshaChartHtml}


              <!-- PRAKRUTI RESPONSES -->

              <h2
                style="
                  margin:30px 0 14px;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:22px;
                  line-height:1.3;
                  font-weight:500;
                  color:#1E3A2F;
                "
              >
                Prakruti Responses
              </h2>


              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  border:1px solid #ECE6DA;
                  border-radius:12px;
                  overflow:hidden;
                "
              >

                ${answersHtml}

              </table>


              <!-- DISCLAIMER -->

              <div
                style="
                  margin-top:30px;
                  padding:20px 22px;
                  background:#F6F5F0;
                  border:1px solid #ECE6DA;
                  border-left:4px solid #C49A5A;
                  border-radius:10px;
                "
              >

                <h3
                  style="
                    margin:0 0 12px;
                    padding:0;
                    font-family:Georgia,serif;
                    color:#1E3A2F;
                    font-size:18px;
                    line-height:1.3;
                    font-weight:600;
                  "
                >
                  Please Note that:
                </h3>


                <p
                  style="
                    margin:0 0 10px;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Dynamic Nature of Prakruti:</strong>
                  The Prakruti analysis aims to assess the current dosha
                  conditions of your body. Please be aware that these
                  conditions are subject to change based on various factors
                  including location, time, environment, diet, seasons,
                  and personal habits.
                </p>


                <p
                  style="
                    margin:0 0 10px;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Limitations of Self-Medication:</strong>
                  It is crucial to understand that Prakruti analysis is not
                  a comprehensive diagnostic tool and should not be used
                  for self-medication.
                </p>


                <p
                  style="
                    margin:0;
                    padding:0;
                    color:#271F12;
                    font-size:12px;
                    line-height:1.6;
                  "
                >
                  <strong>Expert Guidance Required:</strong>
                  For accurate diagnosis and appropriate treatment,
                  consultation with an Ayurveda expert is essential.
                  We strongly recommend seeking the advice and input of
                  Dr. Jigar Gor for any health concerns or Ayurvedic
                  treatment plans. By adhering to these guidelines, you
                  ensure a holistic and accurate approach to your health
                  and well-being.
                </p>

              </div>

            </td>
          </tr>


          <!-- FOOTER -->

          <tr>
            <td
              style="
                background:#271F12;
                padding:25px 30px;
                text-align:center;
              "
            >

              <h3
                style="
                  margin:0;
                  padding:0;
                  font-family:Georgia,serif;
                  font-size:18px;
                  line-height:1.3;
                  font-weight:500;
                  color:#ffffff;
                "
              >
                Dr. Jigar Gor Ayurveda Clinic
              </h3>


              <p
                style="
                  margin:8px 0 0;
                  padding:0;
                  color:#D8C4A1;
                  font-size:11px;
                  line-height:1.5;
                "
              >
                Authentic Ayurveda • Panchkarma • Holistic Healing
              </p>

              <table
  role="presentation"
  cellpadding="0"
  cellspacing="0"
  border="0"
  style="margin:14px auto 0;"
>
  <tr>

    <!-- Email -->
    <td style="padding:0 8px;">
      <a
        href="mailto:dr.jigargor@yahoo.com"
        title="Email"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/new-post.png"
          width="22"
          height="22"
          alt="Email"
          style="display:block;border:0;"
        />
      </a>
    </td>

    <!-- Call -->
    <td style="padding:0 8px;">
      <a
        href="tel:+919099094847"
        title="Call"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/phone.png"
          width="22"
          height="22"
          alt="Call"
          style="display:block;border:0;"
        />
      </a>
    </td>

    <!-- WhatsApp -->
    <td style="padding:0 8px;">
      <a
        href="https://wa.me/+919099094847"
        title="WhatsApp"
        style="text-decoration:none;"
      >
        <img
          src="https://img.icons8.com/ios-filled/50/D8C4A1/whatsapp.png"
          width="22"
          height="22"
          alt="WhatsApp"
          style="display:block;border:0;"
        />
      </a>
    </td>

  </tr>
</table>

            </td>
          </tr>


        </table>

      </td>
    </tr>
  </table>

</div>
`;

   const adminData = new FormData();

adminData.append(
  "title",
  "Prakruti Analysis Submission"
);

adminData.append(
  "to_email",
  "dr.jigargor@yahoo.com"
);

adminData.append(
  "cc",
  "arkayappsseo@gmail.com,sales@arkayapps.com"
);

adminData.append(
  "subject",
  "New Prakruti Analysis Submission"
);

adminData.append(
  "template",
  adminTemplate
);

await axios.post(
  "https://api.sendmail.adhyaynam.in/send-mail/two",
  adminData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);


const userData = new FormData();

userData.append(
  "title",
  "Your Prakruti Analysis Results"
);

userData.append(
  "to_email",
  basicInfo.email
);

userData.append(
  "subject",
  "Your Prakruti Analysis Submission Result"
);

userData.append(
  "template",
  userTemplate
);

await axios.post(
  "https://api.sendmail.adhyaynam.in/send-mail/two",
  userData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);

// ===============================
// SEND WHATSAPP NOTIFICATION
// ===============================

const whatsappData = {
  name: basicInfo.name,
  age: basicInfo.age,
  gender: basicInfo.gender,
  email: basicInfo.email,
  contactNumber: basicInfo.contactNumber,
};

try {
  await axios.post(
    "/.netlify/functions/prakruti-analysis",
    whatsappData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
} catch (whatsappError) {
  console.error(
    "Prakruti WhatsApp notification failed:",
    whatsappError.response?.data || whatsappError
  );
}

const patientPrakrutiData = {
  name: basicInfo.name,
  phoneNumber: basicInfo.contactNumber,
};

await axios.post(
  "/.netlify/functions/patient-prakruti-analysis",
  patientPrakrutiData,
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);

    toast.success(
      "Prakruti Analysis submitted successfully."
    );

    // RESET EVERYTHING

    setAnswers({});

    setBasicInfo({
      name: "",
      age: "",
      gender: "",
      email: "",
      contactNumber: "",
    });

sendMetaEvent("QuizCompleted");
setQuizStarted(false);

    setSubmitted(true);

    setTimeout(() => {

      setSubmitted(false);

      setCurrentStep(0);

      contentRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

    }, 2500);
    sessionStorage.setItem("trackThankYouLead", "true");
    navigate("/thank-you");

  } catch (error) {

    toast.error(
      "Something went wrong. Please try again."
    );

  } finally {

    setLoading(false);

  }
  });

};

const handleBasicInfoChange = (e) => {
  const { name, value } = e.target;

  setBasicInfo((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSelect = (questionId, optionIndex) => {
  trackQuizStart();

  setAnswers((prev) => ({
    ...prev,
    [questionId]: optionIndex,
  }));
};

const totalQuestions =
  Object.keys(basicInfo).length +
  prakrutiSteps
    .filter(
      (step) =>
        !step.isBasicInfo &&
        !step.isReview
    )
    .reduce(
      (acc, step) =>
        acc + step.questions.length,
      0
    );

const basicInfoAnswered =
  Object.values(basicInfo).filter(
    (value) => value.trim() !== ""
  ).length;

const answeredQuestions =
  Object.keys(answers).length +
  basicInfoAnswered;

const progressPercent = Math.round(
  (answeredQuestions / totalQuestions) * 100
);

const isStepCompleted = (stepData) => {

  // Basic information step
  if (stepData.isBasicInfo) {
    return (
      basicInfo.name.trim() !== "" &&
      basicInfo.age.trim() !== "" &&
      basicInfo.gender.trim() !== "" &&
      basicInfo.email.trim() !== "" &&
      basicInfo.contactNumber.trim() !== ""
    );
  }

  // Review step
  if (stepData.isReview) {
    return submitted;
  }

  // Normal question step
  return stepData.questions.every(
    (question) =>
      answers[question.id] !== undefined
  );
};

const canAccessStep = (index) => {

  // First step is always accessible
  if (index === 0) {
    return true;
  }

  // A step can only be accessed when
  // the previous step has been completely answered
  return isStepCompleted(
    prakrutiSteps[index - 1]
  );
};

const handleNext = () => {
   trackQuizStart();

  setCurrentStep(prev => prev + 1);

  setTimeout(() => {
    contentRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 50);

};

const handlePrev = () => {

  setCurrentStep(prev => prev - 1);

  setTimeout(() => {
    contentRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 50);

};

/*const allQuestionsAnswered =
  Object.keys(answers).length ===
  totalQuestions - 5;
const canAccessReview = () => {

  const allBasicInfoFilled =
    basicInfo.name &&
    basicInfo.age &&
    basicInfo.gender &&
    basicInfo.email &&
    basicInfo.contactNumber;

  const allQuestionsAnswered =
    Object.keys(answers).length ===
    totalQuestions - 5;

  return allBasicInfoFilled && allQuestionsAnswered;
};*/

    return(
        <>
      <ToastContainer
  position="top-right"
  autoClose={3000}
/>
           <section className="prakruti-analysis-section container"  ref={contentRef}>

  <motion.div
  className="prakruti-intro"
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.3,
  }}
  variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  }}
>
  <motion.p
    className="section-subheading"
    variants={{
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.9,
          ease: "easeOut",
        },
      },
    }}
  >
    Prakruti Analysis
  </motion.p>

  <motion.h2
    className="section-heading"
    variants={{
      hidden: {
        opacity: 0,
        y: 25,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1,
          ease: "easeOut",
        },
      },
    }}
  >
    Discover Your Unique Ayurvedic Body Type
  </motion.h2>

  <motion.p
    className="section-text"
    variants={{
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1,
          ease: "easeOut",
        },
      },
    }}
  >
    Answer a series of simple questions about your body, mind and lifestyle. Get insights to achieve balance, prevent illness and live a healthier life.
  </motion.p>
</motion.div>

      <div className="prakruti-test-section">

      {/* LEFT */}

    <motion.div
  className="prakruti-sidebar"
  initial={{
    opacity: 0,
    x: -30,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 1,
    ease: "easeOut",
  }}
>
  <motion.div
    className="progress-card"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.2,
    }}
  >
    <h3 className="card-heading">
      Your Progress
    </h3>

    <p className="section-text">
      Step {currentStep + 1} of {prakrutiSteps.length}
    </p>
    <p className="current-category-title section-text">
  {step.title}
</p>
    <div className="progress-bar">
      <motion.div
        className="progress-fill"
        initial={{
          width: 0,
        }}
        animate={{
          width: `${progressPercent}%`,
        }}
        transition={{
          duration: 0.8,
          ease: "easeOut",
        }}
      />
    </div>

    <p className="progress-text section-text">
      {progressPercent}% Completed
    </p>

    <div className="steps-list">
      <div className="step-line"></div>

      {prakrutiSteps.map((item, index) => (
        <motion.button
          key={index}
className={`step-item
  ${index === currentStep ? "active-step" : ""}
  ${isStepCompleted(item) ? "completed" : ""}
  ${!canAccessStep(index) ? "locked-step" : ""}
`}
onClick={() => {

  if (!canAccessStep(index)) {
    return;
  }

  setCurrentStep(index);

  setTimeout(() => {
    document
      .querySelector(
        ".prakruti-analysis-section"
      )
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }, 50);
}}
          initial={{
            opacity: 0,
            x: -15,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            delay: index * 0.08,
            duration: 0.5,
          }}
          whileHover={{
            x: 3,
          }}
          whileTap={{
            scale: 0.98,
          }}
        >
         <span>

 {!canAccessStep(index) ? (
  <FaLock />
) : isStepCompleted(item) ? (
  <FaCheck />
) : (
  index + 1
)}

</span>

          <p className="section-text">
            {item.title}
          </p>
        </motion.button>
      ))}
    </div>
  </motion.div>

  <motion.div
    className="tip-box"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.4,
    }}
  >
    <div className="tip-box-heading">
      <span className="tip-icon">i</span>

      <h3 className="card-heading">
        Ayurvedic Tip
      </h3>
    </div>

    <p className="section-text">
      Prakruti is your natural blueprint.
      Understanding it helps you make
      better lifestyle decisions.
    </p>
  </motion.div>
</motion.div>

      {/* RIGHT */}

  <motion.div
  className="prakruti-content"
  initial={{
    opacity: 0,
    x: 20,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 0.8,
    ease: "easeOut",
  }}
>
  <AnimatePresence mode="wait">

    <motion.div
      key={currentStep}
      className="questions-wrapper"
      initial={{
        opacity: 0,
        y: 30,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{
        opacity: 0,
        y: -30,
      }}
      transition={{
        duration: 0.45,
      }}
    >
      {step.isBasicInfo ? (

  <div className="basic-info-form">

    <div className="basic-info-field">
      <label>Name *</label>
      <input
        type="text"
        name="name"
        value={basicInfo.name}
        onChange={handleBasicInfoChange}
        placeholder="Enter Your Name"
      />
    </div>

    <div className="basic-info-field">
      <label>Age *</label>
      <input
        type="number"
        name="age"
        value={basicInfo.age}
        onChange={handleBasicInfoChange}
        placeholder="Enter Your Age"
      />
    </div>

    <div className="basic-info-field">
      <label>Gender *</label>

      <select
        name="gender"
        value={basicInfo.gender}
        onChange={handleBasicInfoChange}
      >
        <option value="">
          Select Gender
        </option>
        <option value="Male">
          Male
        </option>
        <option value="Female">
          Female
        </option>
        <option value="Other">
          Other
        </option>
      </select>
    </div>

    <div className="basic-info-field">
      <label>Email Address *</label>
      <input
        type="email"
        name="email"
        value={basicInfo.email}
        onChange={handleBasicInfoChange}
        placeholder="Enter Email Address"
      />
    </div>

   <div className="basic-info-field">
  <label>Contact Number *</label>

  <PhoneInput
    country="in"
    value={basicInfo.contactNumber}
    onChange={(phone) =>
      setBasicInfo((prev) => ({
        ...prev,
        contactNumber: phone,
      }))
    }
    enableSearch
    searchPlaceholder="Search country"
    countryCodeEditable={false}
    placeholder="Enter Contact Number"
    inputProps={{
      name: "contactNumber",
      required: true,
    }}
  />
</div>

  </div>

) : step.isReview ?
(
  

  <div className="review-section">

  <h3 className="card-heading">
    Review Your Details
  </h3>

  <div className="review-block">

    <h4>Basic Information</h4>

    <p className="section-text"><strong>Name:</strong> {basicInfo.name}</p>
    <p className="section-text"><strong>Age:</strong> {basicInfo.age}</p>
    <p className="section-text"><strong>Gender:</strong> {basicInfo.gender}</p>
    <p className="section-text"><strong>Email:</strong> {basicInfo.email}</p>
    <p className="section-text"><strong>Contact Number:</strong> {basicInfo.contactNumber}</p>

  </div>

  {prakrutiSteps
    .filter(
      (item) =>
        !item.isBasicInfo &&
        !item.isReview
    )
    .map((category) => (

      <div
        className="review-block"
        key={category.step}
      >

        <h4>{category.title}</h4>

        {category.questions.map((question) => (

         <div
  className="review-answer"
  key={question.id}
>
  <span className="section-text review-question">
    {question.title}:
  </span>

  <span className="section-text">
    {question.options[answers[question.id]]}
  </span>
</div>

        ))}

      </div>

  ))}

 <div className="review-confirmation">

  {!submitted ? (
    <>
      <p className="section-text">
        Are you sure you want to submit your
        details for Prakruti Analysis?
      </p>

      <button
  className="nav-btn"
  onClick={handleSubmit}
  disabled={loading}
>
  {loading
    ? "Submitting..."
    : "Submit Analysis"}
</button>
    </>
  ) : (
    <div className="submission-success">

      <h3 className="card-heading">
        Thank You!
      </h3>

      <p className="section-text">
        Your details have been submitted successfully.
        Our team will review your information and
        contact you soon.
      </p>

    </div>
  )}

</div>

</div>

) : (

  step.questions.map((question, index) => (
   <motion.div
          className="question-row"
          key={index}
          initial={{
            opacity: 0,
            y: 15,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            delay: index * 0.08,
            duration: 0.5,
          }}
        >
          <h3 className="question-title card-heading">
            {question.title}
          </h3>

          <div className="question-options">

            {question.options.map((option, i) => (
              <motion.button
                key={i}
                className={`option-btn ${
                  answers[question.id] === i
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  handleSelect(question.id, i)
                }
                whileHover={{
                  scale: 1.02,
                }}
                whileTap={{
                  scale: 0.98,
                }}
                transition={{
                  duration: 0.2,
                }}
              >
                {option}
              </motion.button>
            ))}

          </div>
        </motion.div>
  ))

)}

      <motion.div
        className="question-nav"
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          delay: 0.2,
        }}
      >
        <motion.button
          disabled={currentStep === 0}
          onClick={handlePrev}
          whileHover={{
            y: -2,
          }}
          whileTap={{
            scale: 0.98,
          }}
        >
          <FaChevronLeft />
          Previous Question
        </motion.button>

        <motion.button
disabled={
  currentStep >= prakrutiSteps.length - 1 ||
  !isStepCompleted(step)
}
onClick={() => {

  if (!isStepCompleted(step)) {
    return;
  }

  if (
    currentStep < prakrutiSteps.length - 1
  ) {
    handleNext();
  }

}}
          whileHover={{
            y: -2,
          }}
          whileTap={{
            scale: 0.98,
          }}
        >
          Next Question
          <FaChevronRight />
        </motion.button>
      </motion.div>

    </motion.div>

  </AnimatePresence>
</motion.div>
</div>
    </section>
        </>
    )
}
export default PrakrutiAnalysisForm;